export default __webpack_public_path__ + "static/media/Page3.17bebe32.txt";